import { render, staticRenderFns } from "./ProjectItemInventory.vue?vue&type=template&id=4449de45&scoped=true"
import script from "./ProjectItemInventory.vue?vue&type=script&lang=js"
export * from "./ProjectItemInventory.vue?vue&type=script&lang=js"
import style0 from "./ProjectItemInventory.vue?vue&type=style&index=0&id=4449de45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449de45",
  null
  
)

export default component.exports